import React from 'react';
import { Section } from './Shared';
import { costs } from '../data/pack';
export const CostComparison = () => {
  return <Section data-id="element-24" data-mp="2avo0rm7o4ba1">
      <div className="mb-12 text-center" data-id="element-25" data-mp="2auwckwgehfts">
        <h2 className="font-display text-[22px] font-bold uppercase tracking-[0.12em] text-brand-burgundy md:text-4xl" data-id="element-26" data-mp="26uma3trth7jo">
          What Does It Cost to Keep Improvising?
        </h2>
      </div>

      <div className="mx-auto max-w-4xl" data-id="element-27" data-mp="2ym1s1aifi63k">
        <div className="hidden md:block" data-id="element-28" data-mp="2ykqrrko6zgh7">
          <div className="divide-y divide-brand-goldDark/15 border-y border-brand-goldDark/20" data-id="element-29" data-mp="2yjped9jpehwb">
            {costs.map(row => <div key={row.without} className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] items-center gap-6 px-5 py-4" data-id="element-30" data-mp="2pku5tqt6svpu">
                <div className="text-sm font-medium text-brand-text" data-id="element-31" data-mp="1e66zdjfpxbe5">
                  {row.without}
                </div>
                <div className="flex items-start gap-2 text-sm font-medium text-brand-burgundy/90" data-id="element-32" data-mp="196khuxsux8zj">
                  <span aria-hidden="true" data-id="element-33" data-mp="2laj1hfdo3nxa">→</span>
                  <span data-id="element-34" data-mp="2l8oezwmqznr3">{row.cost}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="space-y-4 md:hidden" data-id="element-35" data-mp="2bclbong5tj2k">
          {costs.map(row => <div key={row.without} className="paper-panel space-y-2 rounded-xl p-4" data-id="element-36" data-mp="2bez7wzmkt1bp">
              <p className="text-sm font-medium text-brand-text" data-id="element-37" data-mp="21n1s1fkmhl6n">
                {row.without}
              </p>
              <div className="flex items-start gap-2 font-medium text-brand-burgundy/90" data-id="element-38" data-mp="26drzcyclzy3z">
                <span aria-hidden="true" className="shrink-0" data-id="element-39" data-mp="1smn6qg7ns635">
                  →
                </span>
                <span className="text-sm" data-id="element-40" data-mp="1xkezfcg4nw8e">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="mt-14 text-center" data-id="element-41" data-mp="1ioh601xl95zv">
        <p className="mx-auto max-w-2xl font-serif text-xl font-semibold italic text-brand-burgundy md:text-2xl" data-id="element-42" data-mp="1nn0r604cydr6">
          You do not need to become a different instructor. You need a better
          system behind the instructor you already are.
        </p>
      </div>
    </Section>;
};